import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, TextLink } from '@vds/buttons';
import { Title, Body } from '@vds/typography';
import { Row, Col, Grid } from '@vds/grids';
import './InternetOptions.css';
import { redirectionHandler } from '../containers/action';
import * as SiteCatalyst from '../../../sitecatalyst';
import { isNightTimeWindow } from './../../../utils/common';


 
class InternetOptions extends Component {
        constructor(props) {
            super(props);
            window.scrollTo(0, 0);
            this.state= {
                endInteraction: false,
            };
        }
        componentDidMount() {
            SiteCatalyst.trackPageInfo('Internet Options');
            this.setState({ endInteraction: true });
            SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
        }
    
        componentDidUpdate = () => {
            if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
                window.newrelic.interaction().end();
                this.setState({ endInteraction: false });
            }
        }
        btnHandler = (hsiFlow) => {
           if(hsiFlow){
            this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
            let doLoopResponse = this.props.addressQualificationDetails;
            SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
            if ( !isNightTimeWindow()) {
                SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                SiteCatalyst.trackProductsList(window.LQResponse);
                //SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                //SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                if (window?.newrelic?.addPageAction) {
                    window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                }
            }
           } else{
            this.props.redirectionHandler()
           } 
        }
    render() {

    return (
        <>
           <Grid className="OutofFranchise" style= {{marginLeft:'3px',marginTop:'30px'}} colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }} colGutter={false}>
                <Row className="Page-Content">
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className="Main-Title ft-sz-75 mb-vw-mar-tp-50">
                            <Title size="large" primitive="h2">
                            Your address qualifies for multiple <br />business internet services.
                            </Title>
                        </div>
                    </Col>
                    <Col className="Title-section mar-tp-30" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className="Main-Title">
                            <Title size="small" primitive="h2">
                            LTE Business Internet
                            </Title>
                        </div>
                        <div className='mar-tp-20'>
                        <Body size="medium" primitive="h1">With speeds up to 50 Mbps, LTE Business Internet is ideal for small office, retail, kiosk and mobile businesses. Each plan includes 300GB of  monthly data without speed thresholds, no matter how much of your data you use. Great for email, web browsing, file sharing and point of sale systems.
                        </Body>
                        </div>
                    </Col>
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className="Main-Title mar-tp-20">
                        <Button primary size="medium" onClick={() => this.btnHandler(false)} >Shop LTE Business Internet</Button>

                        </div>
                    </Col>
                </Row>
                <Row className="Page-Content mar-tp-50">
                    <Col className="Title-section" colSizes={{ "mobile": 4, "tablet": 9, "desktop": 9 }}>
                        <div className="Main-Title">
                      <Body size="medium" primitive="h2"> High speed internet, with speeds up to 10/15 Mbps, is also available in your area. <br/>
                      <TextLink size="small" onClick={() => this.btnHandler(true)}>Shop High Speed Internet</TextLink></Body>
                        </div>
                    </Col>
                    </Row>
            </Grid >
        </>);
}
}

const mapStateToProps = (state) => {
    const { AddressValidationPage } = state;
    return {
        addressQualificationDetails: AddressValidationPage.addressQualificationDetails
    };
};
const mapDispatchToProps = (dispatch) => ({
    redirectionHandler: (data) => { dispatch(redirectionHandler(data)); },

})

export default connect(mapStateToProps, mapDispatchToProps)(InternetOptions)